<template>
  <div>
    <vetster-time-frame-picker @selected="$emit('time-selected')" />
    <div class="flex items-center justify-between text-xs mt-4">
      <div class="text-neutral-600">
        {{ $t('app.timezone') }}:
        <span class="font-semibold">
          {{ humanReadableTimezone(inputs.timezone) }}
        </span>
      </div>
      <button
        v-show="!shouldShowTimezones"
        class="text-indigo-600 hover:text-indigo-500 hover:opacity-50 cursor-pointer focus:outline-none focus:underline"
        type="button"
        @click="showTimezones"
      >
        {{ $t('app.change?') }}
      </button>
    </div>
    <vetster-select
      v-if="shouldShowTimezones"
      v-model="timezone"
      :options="getTimezoneOptions(getInputs.timezone)"
      class="mt-2"
      @change="hideTimezones"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import VetsterSelect from '@/components/VetsterSelect';
import VetsterTimeFramePicker from '@/components/VetsterTimeFramePicker';
import useTimezoneHelpers from '@/composables/use-timezone-helpers';

export default {
  name: 'VetsterSearchTimePicker',

  components: {
    VetsterSelect,
    VetsterTimeFramePicker,
  },

  setup() {
    const {
      getTimezoneOptions,
      humanReadableTimezone,
    } = useTimezoneHelpers();

    return {
      getTimezoneOptions,
      humanReadableTimezone,
    };
  },

  data() {
    return {
      shouldShowTimezones: false,
      timezone: '',
    };
  },

  computed: {
    ...mapState('search', ['inputs']),
    ...mapGetters('search', [
      'getInputs',
    ]),
  },

  watch: {
    timezone(timezone) {
      this.$store.commit('search/setInputs', {
        timezone,
      });
    },
  },

  created() {
    this.timezone = this.inputs.timezone;
  },

  methods: {
    hideTimezones() {
      this.shouldShowTimezones = false;
    },

    showTimezones() {
      this.shouldShowTimezones = true;
    },
  },
};
</script>
